import React from "react";
import { useTranslation } from "react-i18next";

import { format } from "date-fns";

import { handleKeyDown } from "fe-shared/src/helpers/buttonHandlers";
import IMAGE_PLACEHOLDER from "fe-shared/src/assets/images/image-placeholder.png";

import { ScaleTicket } from "../../types";
import styles from "./ScaleTicketsInfo.module.scss";

interface Props {
  scaleTickets: ScaleTicket[];
  onClick: (key: string) => void;
  isAdjustment?: boolean;
}

const ticketNames = [
  "correction.dialog.inputs.firstTicketNumber",
  "correction.dialog.inputs.secondTicketNumber",
];

const ScaleTicketsInfo = (props: Props) => {
  const { scaleTickets, onClick, isAdjustment } = props;

  const { t } = useTranslation();

  if (isAdjustment) {
    return (
      <div className={styles.ticketsList}>
        <span className={styles.ticketsListHeader}>
          {t("transactions.details.scaleTicket.header")}
        </span>
        {scaleTickets.map((item, index) => (
          <div key={item.ticketNumber}>
            <span className={styles.ticketsListItem}>
              {t(ticketNames[index])}
            </span>
            <span className={styles.ticketsListItem}>{item.ticketNumber}</span>
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className={styles.tiresReportWrapper}>
      {scaleTickets.map((item) => {
        const isTicketImage = !!item.ticket;
        const onClickHandler = () => isTicketImage && onClick(item.ticket!);
        const imageSrc = item.ticket || IMAGE_PLACEHOLDER;

        return (
          <div key={`${item.ticketNumber}${item.createdDate.toString()}`} className={styles.tireReport}>
            <div
              tabIndex={0}
              role="button"
              onClick={onClickHandler}
              onKeyDown={(e) => handleKeyDown(e, onClickHandler)}
            >
              <img className={styles.tireReportPic} src={imageSrc} alt="" />
            </div>
            <span>{`#${item.ticketNumber}`}</span>
            <span>
              {format(
                new Date(item.scaleTicketDate ?? item.createdDate),
                "MMM d, yyyy"
              )}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ScaleTicketsInfo;
